import { Avatar, Menu, Space } from 'antd'
import {
  // BarChartOutlined,
  DownOutlined,
  LogoutOutlined,
  // PoweroffOutlined,
  // SnippetsOutlined,
  // TeamOutlined,
  CopyOutlined,
  UserOutlined,
} from '@ant-design/icons'
import React from 'react'

import classes from '../../../pages/LoginPage/Login.module.scss'
import { useUserSelector } from '@store/selectors/auth'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '@store/hooks'
import { authLogout } from '@store/auth/thunk'
import { useModalContext } from '@context/modalContext'
import DropdownUI from '@components/ui/DropDownUI/DropdownUi'
import ProfileUpdateModal from '@components/Modals/ProfileUpdate/ProfileUpdate.modal'
import { routersPath } from '@router/routes-path'
import axiosInstance from '@config/axios'
import { serverPath } from '@constants/api-endpoints'
import useCopyToClipboard from '@hooks/useClipboard'

interface MenuClickEventHandler {
  key: string
}
export const AdminProfileDrop = React.memo(() => {
  const user = useUserSelector()
  const dispatch = useAppDispatch()
  const { setModalComponent } = useModalContext()
  const navigator = useNavigate()
  const handleCopy = useCopyToClipboard()

  const getHash = async () => {
    const { data } = await axiosInstance.get(serverPath.HASH)
    handleCopy(data)
  }

  const handler = (e: MenuClickEventHandler | undefined) => {
    switch (e?.key) {
      case 'profile': {
        user &&
          setModalComponent({
            component: (
              <ProfileUpdateModal
                update={() => {
                  navigator(routersPath.LOGIN_PAGE)
                }}
              />
            ),
            maskClosable: true,
          })
        break
      }
      case 'hash': {
        getHash()
        break
      }
      case 'exit': {
        dispatch(authLogout())
        break
      }
      case 'powerOff': {
        console.log('Power OFF CRM')
        break
      }
      default:
        return
    }
  }

  const AdminProfile = (
    <Menu
      onClick={handler}
      items={[
        {
          key: 'profile',
          label: <span>Профиль</span>,
          icon: <UserOutlined />,
        },
        {
          key: 'hash',
          label: <span>Получить хеш</span>,
          icon: <CopyOutlined />,
        },
        // {
        //   key: routersPath.STAT_PAGE,
        //   label: (
        //     <NavLink to={routersPath.STAT_PAGE}>
        //       <span>Статистика</span>
        //     </NavLink>
        //   ),
        //   icon: <BarChartOutlined />,
        // },
        // {
        //   key: routersPath.MANAGERS_PAGE,
        //   label: (
        //     <NavLink to={routersPath.MANAGERS_PAGE}>
        //       <span>Менеджеры</span>
        //     </NavLink>
        //   ),
        //   icon: <TeamOutlined />,
        // },
        // {
        //   key: routersPath.SCRIPTS_PAGE,
        //   label: (
        //     <NavLink to={routersPath.SCRIPTS_PAGE}>
        //       <span>Скрипты</span>
        //     </NavLink>
        //   ),
        //   icon: <SnippetsOutlined />,
        // },
        // {
        //   key: 'powerOff',
        //   label: <span>Выключить CRM</span>,
        //   icon: <PoweroffOutlined />,
        //   disabled: true,
        // },
        // {
        //   type: 'divider',
        // },
        {
          key: 'exit',
          label: <span>Выход</span>,
          icon: <LogoutOutlined />,
        },
      ]}
    />
  )
  return (
    <DropdownUI menu={AdminProfile}>
      <Space style={{ cursor: 'pointer' }}>
        <Avatar size={30} className={classes.avatar} icon={<UserOutlined />} />
        {user?.nickName ?? 'Нет имени'}
        <DownOutlined />
      </Space>
    </DropdownUI>
  )
})
